<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     新增商品-选择 商品类目
  +---------------------------------------------------------------------------------------
-->

<template>
  <el-dialog class="new-category" width="1200px" :visible.sync="dialogShow" :modal-append-to-body="false" :close-on-click-modal="false" @close="onDialogClose">
    <span slot="title">
      <span class="font-lg">选择商品类目</span>
    </span>

    <div v-loading="loading" style="padding: 0 157px;margin-top: -15px;">
      <div class="filter-item" style="width: 240px;">
        <el-select v-model="keyword" placeholder="搜索商品类目" :clearable="true" autocomplete="off" filterable remote :remote-method="remoteMethod" style="width: 100%;" @change="onSelectChange">
          <el-option v-for="(item, index) in list" :key="index" :value="index" :label="item.cat_name">
            <div class="flex">
              <span>{{ item.cat_name }}</span>
            </div>
          </el-option>
        </el-select>
      </div>
      <el-cascader-panel v-model="category" :props="{ expandTrigger: 'click', checkStrictly: true }" class="mt-lg cascader-panel" :options="options" @change="cascaderChange" :key="isResouceShow" />
    </div>

    <div slot="footer" class="text-center mb">
      <el-button class="extend" @click="cancel">取 消</el-button>
      <el-button class="extend" type="primary" @click="next()" :disabled="category.length < 3">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getfewCategoryApi, getProductCategoryApi } from '@/api/ei/eiMallApi'
export default {
  name: 'NewCategory',

  props: {
    show: {
      type: Boolean,
      default: false
    },
    arr: {
      type: Array,
      default() {
        return []
      }
    }
  },

  data () {
    return {
      isResouceShow: 0,
      loading: false,
      keyword: '',
      selectLoading: false,
      list: [],
      category: [],
      options: []
    }
  },

  computed: {
    dialogShow: {
      get () {
        return this.show
      },
      set (val) {
        this.$emit('update:show', val)
      }
    }
  },

  created () {
    if (this.arr.length) {
      this.category = this.arr
    }
    this.fetchCategory()
  },

  methods: {
    fetchCategory () {
      this.loading = true
      getProductCategoryApi().then(res => {
        this.loading = false
        if (res.errno === 0) {
          this.options = res.data
        } else {
          this.$message.error(res.message)
        }
      })
    },

    remoteMethod (query) {
      if (query !== '') {
        this.list = []
        this.selectLoading = true
        getfewCategoryApi({ 'cat_name': query }).then(res => {
          if (!res.errno) {
            this.list = res.data
            this.selectLoading = false
          } else {
            this.$message.error(res.message)
          }
        }).catch(() => {
        })
      } else {
        this.list = []
      }
    },

    cascaderChange (e) {
    },

    onSelectChange (index) {
      if (index === 0 || index > 0) {
        this.category = []
        ++this.isResouceShow
        setTimeout(() => {
          const temp = this.list[index]
          if (temp.level === 1) this.category.push(temp.first_cat_id)
          if (temp.level === 2) this.category.push(temp.first_cat_id, temp.second_cat_id)
          if (temp.level === 3) this.category.push(temp.first_cat_id, temp.second_cat_id, temp.third_cat_id)
        }, 200)

      }
    },

    handleSelect (item) {
    },

    fetchList () { },

    onDialogClose () { },

    next () {
      this.$emit('change', this.category[2])
      this.dialogShow = false
    },

    cancel () {
      this.dialogShow = false
    }
  }
}
</script>

<style lang="scss">
.new-category {
  .el-cascader-menu {
    width: 280px;
  }
  .el-cascader-menu__wrap {
    height: 400px;
  }
  .cascader-panel {
    max-height: 400px;
  }
}
</style>
